import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import  { Suspense, lazy } from 'react';
import LandingPage from './route/uauth/index_oneorbit'
import LoginPage from './route/auth/login'
import SignupPage from './route/auth/sign_up'
import ForgotPasswordPage from './route/auth/forgot_password'
import SetPassword from './route/auth/set_password'
import VerifyEmailPage from './route/auth/verify_email'
import DashboardPage from './route/protected/dashboard'
import ProfilePage from './route/protected/profile'
import TransactionPage  from './route/protected/transaction'
import TransactionDetailPage from './route/protected/transaction/detail/'
import BusinessListPage from './route/protected/module/business'
import AddBusiness from './route/protected/module/business/add_business'
import BusinessDetailPage from './route/protected/module/business/detail'
import GiveawayPage from './route/protected/module/giveaway'
import GiveawayDetailPage from './route/protected/module/giveaway/detail'
import EvotingPage from './route/protected/module/evoting'
import EvotingDetailPage from './route/protected/module/evoting/detail'
import PollPage from './route/protected/module/evoting/poll'
import PollResultPage from './route/protected/module/evoting/poll-result'
import VotingInterestPage from './route/protected/module/evoting/interested'


import AirtimePage from './route/protected/module/airtime'
import AirtimeDetailPage from './route/protected/module/airtime/detail'



import "./firebase/firebase";
import 'antd/dist/antd.css';
//import "./assets/assets.css";

function App() {
  return (
    <Router>
      <div className="App" id="App">
      <Suspense fallback={<div class="full-page-loader">
            <img width="200" src="/web/assets/img/Icon.png" alt="TradexSafely.Trade logo" />
          </div>}>
        <Switch>
          {/* <Route path="/" exact render={( props) => <AsyncLandingPageComponent { ...props } value="1" />} /> */}
          {/* Main App */}
          <Route path="/" exact component={LandingPage} />
          <Route path="/signin" exact component={LoginPage} />
          <Route path="/signup" exact component={SignupPage} />
          <Route path="/forgot-password" exact component={ForgotPasswordPage} />
          <Route path="/reset-password/:token" exact component={SetPassword} />
          <Route path="/verify/email/:token" exact component={VerifyEmailPage} />
          <Route path="/dashboard" exact component={DashboardPage} />
          <Route path="/profile" exact component={ProfilePage} />
          <Route path="/transactions" exact component={TransactionPage} />
          <Route path="/transaction/detail/:ref" exact component={TransactionDetailPage} />
          <Route path="/giveaways" exact component={GiveawayPage} />
          <Route path="/giveaway/detail/:orderRef" exact component={GiveawayDetailPage} />
          <Route path="/evoting" exact component={EvotingPage} />
          <Route path="/evoting/detail/:uid" exact component={EvotingDetailPage} />
          <Route path="/vote/interest/:uid" exact component={VotingInterestPage} />
          <Route path="/vote/poll/:uid" exact component={PollPage} />
          <Route path="/vote/result/:uid" exact component={PollResultPage} />
          <Route path="/airtime/disbursement" exact component={AirtimePage} />
          <Route path="/airtime/disbursement/detail/:orderRef" exact component={AirtimeDetailPage} />
          <Route path="*" component={LandingPage} />
          <Route  component={LandingPage} />

          
          
        </Switch>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
